import { z } from "zod";

/** One affected thing: a line, a charge, or the order header. */
export const ErpErrorReportItemSchema = z.object({
  label: z.string(),
  value: z.string().optional(),
});

/** Everything that failed for the same underlying reason. */
export const ErpErrorReportGroupSchema = z.object({
  reason: z.string(),
  summary: z.string(),
  remediation: z.string().optional(),
  items: z.array(ErpErrorReportItemSchema),
});

/** ERP-agnostic, user-facing description of why a sync failed. */
export const ErpErrorReportSchema = z.object({
  headline: z.string(),
  groups: z.array(ErpErrorReportGroupSchema),
  /** The ERP's own message for the raw-response affordance. */
  raw: z.string().optional(),
});

/** JSONB metadata stored on an `ERP_SYNC_FAILED` processing error. */
export const ErpSyncErrorMetaSchema = z
  .object({
    message: z.string().optional(),
    report: ErpErrorReportSchema.optional(),
  })
  .passthrough();

export type ErpErrorReportItem = z.infer<typeof ErpErrorReportItemSchema>;
export type ErpErrorReportGroup = z.infer<typeof ErpErrorReportGroupSchema>;
export type ErpErrorReport = z.infer<typeof ErpErrorReportSchema>;
export type ErpSyncErrorMeta = z.infer<typeof ErpSyncErrorMetaSchema>;
